export default __webpack_public_path__ + "static/media/react.7b78f5c3.svg";